import { chatKindOf } from '@bt-common/schemas/wa/chat-kind';
import RowStack from "@common-components/common/row-stack/RowStack";
import { Box } from "@mui/material";
import { calculatedWaContactName, extractPhoneNumber, selectWhatsappContactById } from "@common-reducers/WhatsAppSelectors";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { useMemo } from "react";
import { CellProps } from "../cell-interface";
import { PhoneDisplay } from "../phone-number-cell/phone-display";
import ContactAvatar from "@extension/context/content/components/bulk-dashboard/contact-table/contact-avatar";
import { getTextDirectionAndAlignment } from "@common/utils/text-direction";

export const WhatsappIdScrollingCell = ({
    cellValue,
    taskId,
    columnId,
}: CellProps) => {
    const contact = useAppSelector((state) => selectWhatsappContactById(state, cellValue));
    const phoneNumber = useMemo(() => extractPhoneNumber(cellValue), [cellValue]);
    const contactName = useMemo(() => contact ? calculatedWaContactName(contact) : '', [contact]);
    const isGroup = useMemo(() => chatKindOf(cellValue) === 'group', [cellValue]);
    const isChannel = useMemo(() => chatKindOf(cellValue) === 'channel', [cellValue]);
    const { direction, textAlign } = getTextDirectionAndAlignment(contactName);

    return (

        <RowStack
            sx={{
                px: 1,
                overflow: 'hidden',
            }}
            flex={1}
            justifyContent={'center'}
        >
            {cellValue ?
                <>
                    <ContactAvatar
                        sx={{ mr: 1 }}
                        contactId={cellValue}
                        size={24}
                        textSize={12}
                    />
                    {contactName && <Box sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        direction,
                        textAlign,
                    }} dir={direction}>
                        {contactName}
                    </Box>}

                    {!contactName && !isGroup && !isChannel && <PhoneDisplay phone={phoneNumber} />}
                </> :
                <Box sx={{ fontStyle: 'italic', fontSize: 12, width: 1, textAlign: 'center' }}>
                    Click to add a contact
                </Box>}
        </RowStack>

    )
}